import axios from 'axios';

import {catchAsync} from 'utils/catchAsync';

const getItems = (payload) => {
    if (Array.isArray(payload)) {
        return payload;
    }

    if (!payload || typeof payload !== 'object') {
        return [];
    }

    if (Array.isArray(payload.items)) {
        return payload.items;
    }

    if (Array.isArray(payload.news)) {
        return payload.news;
    }

    if (Array.isArray(payload.results)) {
        return payload.results;
    }

    if (Array.isArray(payload.content)) {
        return payload.content;
    }

    if (Array.isArray(payload.rows)) {
        return payload.rows;
    }

    if (payload.data && typeof payload.data === 'object') {
        return getItems(payload.data);
    }

    return [];
};

const toPositiveNumber = (value, fallback) => {
    const parsedValue = Number(value);

    return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : fallback;
};

const normalizeNewsListResponse = (payload, page, limit) => {
    const items = getItems(payload);
    const pagination = (payload && (payload.pagination || payload.meta)) || {};
    const currentPage = toPositiveNumber(
        pagination.page || payload.page || payload.currentPage,
        page
    );
    const totalPages = toPositiveNumber(pagination.totalPages || payload.totalPages, 0);
    const nextPageFromResponse = toPositiveNumber(pagination.nextPage || payload.nextPage, 0);
    const hasMoreFlag =
        typeof (payload && payload.hasNextPage) === 'boolean'
            ? payload.hasNextPage
            : typeof (payload && payload.hasMore) === 'boolean'
              ? payload.hasMore
              : null;

    const hasNextPage =
        hasMoreFlag !== null
            ? hasMoreFlag
            : nextPageFromResponse > 0
              ? true
              : totalPages > 0
                ? currentPage < totalPages
                : items.length >= limit;

    return {
        items: Array.isArray(items) ? items : [],
        nextPage: hasNextPage ? nextPageFromResponse || currentPage + 1 : undefined,
        hasNextPage
    };
};

export const fetchNewsList = ({ page = 1, limit = 12 } = {}) =>
    catchAsync(async () => {
        const { data } = await axios.get('news/fetch', {
            params: {
                page,
                limit
            }
        });

        return normalizeNewsListResponse(data, page, limit);
    });
